module.exports = __webpack_public_path__ + "img/chevron-left.08573609.svg";